export default function packageReportsDirective() {
  return {
    template: require('./package-reports.html'),
    controller: 'PackageReportsController',
    controllerAs: 'packageReportsVM',
    bindToController: true,
    replace: true,
  };
}
